export default function CardIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" {...props}>
			<path d="M14.95 33h11.9v-1.55h-11.9Zm0-8.25h18.1v-1.5h-18.1Zm0-8.2h18.1V15h-18.1ZM10.75 40q-1.15 0-1.95-.8T8 37.25v-26.5q0-1.15.8-1.95t1.95-.8h26.5q1.15 0 1.95.8t.8 1.95v26.5q0 1.15-.8 1.95t-1.95.8Zm0-1.55h26.5q.45 0 .825-.375.375-.375.375-.825v-26.5q0-.45-.375-.825-.375-.375-.825-.375h-26.5q-.45 0-.825.375-.375.375-.375.825v26.5q0 .45.375.825.375.375.825.375Zm-1.2-28.9V38.45 9.55Z" />
		</svg>
	)
}
